import axios from "axios";
import { Api_url } from "./NETWORKCONSTS";

const formatCorporateParam = (corporateId) => {
    if (!corporateId) return {};
    if (typeof corporateId === "object") return corporateId;
    return { Id: corporateId };
};

// --- ۱۴ گزارش داشبورد تحلیلی جدید سازمان ---

export function Report_corporateSummary(corporateId) {
    return axios.get(Api_url.report.corporateSummary, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateBudgetByMonth(corporateId) {
    return axios.get(Api_url.report.corporateBudgetByMonth, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateCreditHealth(corporateId) {
    return axios.get(Api_url.report.corporateCreditHealth, { params: formatCorporateParam(corporateId) });
}

export function Report_corporatePersonnelByMonth(corporateId) {
    return axios.get(Api_url.report.corporatePersonnelByMonth, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateCreditAllocatedByMonth(corporateId) {
    return axios.get(Api_url.report.corporateCreditAllocatedByMonth, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateCreditCountByMonth(corporateId) {
    return axios.get(Api_url.report.corporateCreditCountByMonth, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateParticipationByWeek(corporateId) {
    return axios.get(Api_url.report.corporateParticipationByWeek, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateGender(corporateId) {
    return axios.get(Api_url.report.corporateGender, { params: formatCorporateParam(corporateId) });
}

export function Report_corporatePopularSports(corporateId) {
    return axios.get(Api_url.report.corporatePopularSports, { params: formatCorporateParam(corporateId) });
}

export function Report_corporatePopularPlaces(corporateId) {
    return axios.get(Api_url.report.corporatePopularPlaces, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateHotspots(corporateId) {
    return axios.get(Api_url.report.corporateHotspots, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateTopPersonnel(corporateId) {
    return axios.get(Api_url.report.corporateTopPersonnel, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateTicketsWithoutEntry(corporateId) {
    return axios.get(Api_url.report.corporateTicketsWithoutEntry, { params: formatCorporateParam(corporateId) });
}

export function Report_corporateEntriesByWeekday(corporateId) {
    return axios.get(Api_url.report.corporateEntriesByWeekday, { params: formatCorporateParam(corporateId) });
}

// --- گزارش‌های گذشته (جهت سازگاری کامل) ---

export function Report_useCorporateCharge(corporateId) {
    return axios.get(Api_url.report.useCorporateCharge, { params: formatCorporateParam(corporateId) });
}

export function Report_ticketBuyCountThisWeek(corporateId) {
    return axios.get(Api_url.report.ticketBuyCountThisWeek, { params: formatCorporateParam(corporateId) });
}

export function Report_getGenderCompetition(corporateId) {
    return axios.get(Api_url.report.getGenderCompetition, { params: formatCorporateParam(corporateId) });
}

export function Report_getPopularSports(corporateId) {
    return axios.get(Api_url.report.getPopularSports, { params: formatCorporateParam(corporateId) });
}

export function Report_getActivePersonnel(corporateId) {
    return axios.get(Api_url.report.getActivePersonnel, { params: formatCorporateParam(corporateId) });
}

export function Report_getActiveInEnterPlacePersonnel(corporateId) {
    return axios.get(Api_url.report.getActiveInEnterPlacePersonnel, { params: formatCorporateParam(corporateId) });
}

export function Report_getBalanceChangedReport(corporateId) {
    return axios.get(Api_url.report.getBalanceChangedReport, { params: formatCorporateParam(corporateId) });
}

export function Report_getAiReport(corporateId) {
    return axios.get(Api_url.report.getAiReport, { params: formatCorporateParam(corporateId) });
}
